module.exports = __webpack_public_path__ + "static/media/gM2.ada3fb9b.jpg";